import { useContext, useState } from "react";
import useGlobalContext from "../context/useGlobalContext";
import { GlobalContext } from "../context/GlobalContext";
import { Box } from "@mui/system";
import ClientAsk7G from "../components/ClientOverview/ClientAsk7G";
import TaskNotifications from "../components/ActionItems/TaskNotifications";
import AppNotification from "../components/Common/AppNotification";
import OpportunityIcon from "../assets/sidebar/opportunity-icon.svg";
import { useNotificationCount } from "../hooks/useNotificationCount";
import { Typography } from "@mui/material";
import Opportunities from "../components/Opportunities/Opportunities";
import RightArrowIcon from "../assets/common/right-arrow-icon.svg";
import { format } from "date-fns";
import "../styles/interactions.css";

const OpportunitiesPage = () => {
  const { accountDetails } = useContext(GlobalContext);
  const { featureMap } = useGlobalContext();
  const isNotificationsEnabled = featureMap?.in_app_notifications === true;
  const userProfileOrgId = accountDetails?.profileOrgId ?? "";
  const userNotification = useNotificationCount(userProfileOrgId, isNotificationsEnabled);
  const Ask7GEnabled = featureMap?.business_ask7g === true;
  const [isAsk7GExpanded, setIsAsk7GExpanded] = useState(false);
  const [opportunityDateRange, setOpportunityDateRange] = useState<{
    preset: string;
    startDate: string;
    endDate: string;
  } | null>(null);

  return (
    <Box
      id="meetingsParent"
      className="flex flex-col justify-start items-start gap-6 m-2"
      style={{ width: "auto" }}
    >
      <div className="interaction-breadcrumbs flex flex-row items-center w-full mt-2">
      <div className="flex flex-row justify-start items-center gap-2">
      <Box
        component={isAsk7GExpanded ? "button" : "div"}
        type={isAsk7GExpanded ? "button" : undefined}
        className={`flex flex-row justify-start items-center gap-2 ask7g-home-breadcrumb ${
          isAsk7GExpanded ? "ask7g-home-breadcrumb--expanded" : "ask7g-home-breadcrumb--collapsed"
        }`}
        onClick={isAsk7GExpanded ? () => setIsAsk7GExpanded(false) : undefined}
      >
        <img src={OpportunityIcon} alt="" className={`breadCrumbs-text ${isAsk7GExpanded ? "breadCrumbs-text--expanded" : "" }`} />
        <Typography className={`breadCrumbs-text ${isAsk7GExpanded ? "breadCrumbs-text--expanded" : "breadCrumbs-text--collapsed" }`} sx={{fontSize: "16px"}}>Opportunities</Typography>
      </Box>
        {opportunityDateRange?.startDate && opportunityDateRange?.endDate && !isAsk7GExpanded &&(
          <span className="interactions-date-range">
            {" "}
            ({format(new Date(opportunityDateRange.startDate), "MMM dd yyyy")} - {format(new Date(opportunityDateRange.endDate), "MMM dd yyyy")})
          </span>
        )}
      {Ask7GEnabled && isAsk7GExpanded && (
        <>
          <img src={RightArrowIcon} alt="" style={{marginTop: "3px"}} />
          <Typography className="breadCrumbs-text ask7g-current-breadcrumb" sx={{fontSize: "16px"}}>
            Ask 7G
          </Typography>
        </>
      )}
      </div>
      <div className="ml-auto flex flex-row items-center gap-3">
        {isNotificationsEnabled && (
          <AppNotification
          notificationCount= {userNotification.notificationCount}
          notificationApiRefetch = {userNotification.getNotificationCountRefetch}
          contentComponent={<TaskNotifications userNotification={userNotification}/>}
          />
        )}
        {Ask7GEnabled && (
          <ClientAsk7G
            view="icon"
            isExpanded={isAsk7GExpanded}
            onToggleExpand={setIsAsk7GExpanded}
          />
        )}
        </div>
      </div>
      {Ask7GEnabled && (
        <Box sx={{ width: "100%", display: isAsk7GExpanded ? "block" : "none" }}>
          <ClientAsk7G
            view="full"
            isExpanded={isAsk7GExpanded}
            onToggleExpand={setIsAsk7GExpanded}
          />
        </Box>
      )}
      <Box sx={{ display: isAsk7GExpanded ? "none" : "block", width: "100%" }}>
        <Opportunities setOpportunityDateRange={setOpportunityDateRange} />
      </Box>
    </Box>
  );
}

export default OpportunitiesPage;
